import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  ScrollArea,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { CreateProviderZoneDto } from "@reactive-resume/dto";
import { useUpdateProviderZone } from "@/client/services/payment-provider/update-provider-zones";
import { useAllProviders } from "@/client/services/payment-provider/providers";
import { useDialog } from "@/client/stores/dialog";
import { ProviderZone } from "@reactive-resume/dto";
import { useEffect } from "react";
import { countries } from "@reactive-resume/utils";

export const EditProviderZoneDialog = () => {
  const { isOpen, close, payload, mode } = useDialog<ProviderZone>("edit-zone");
  const form = useForm<CreateProviderZoneDto>({
    defaultValues: {
      country: payload?.item?.country || "",
      currency: payload?.item?.currency || "",
      priority: payload?.item?.priority || 1,
      providerId: payload?.item?.provider?.id || "",
    },
  });
  const updateProviderZone = useUpdateProviderZone();
  const { providers } = useAllProviders();

  const onSubmit = (data: any) => {
    let payloadToSaved: Partial<CreateProviderZoneDto> = {};
    if (data.priority) {
      payloadToSaved = {
        ...data,
        priority: Number(data.priority),
      };
    } else {
      payloadToSaved = data;
    }

    if (payload?.item) {
      updateProviderZone.mutate(
        { id: payload.item.id, data: payloadToSaved },
        {
          onSuccess: () => {
            form.reset();
            close();
          },
        },
      );
    }
  };
  useEffect(() => {
    if (payload) {
      form.reset({
        country: payload.item?.country || "",
        currency: payload.item?.currency || "",
        priority: payload.item?.priority || 1,
        providerId: payload.item?.provider.id || "",
      });
    }
  }, [payload]);

  if (mode !== "update") return null;
  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Éditer Zone Fournisseur</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              name="country"
              control={form.control}
              render={({ field }) => (
                //champs du pays
                <FormItem className="my-3">
                  <FormLabel>Pays</FormLabel>
                  <Select
                    {...field}
                    onValueChange={(value) => {
                      form.setValue("country", value);
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Choisissez votre pays" />
                    </SelectTrigger>
                    <SelectContent>
                      <ScrollArea orientation="vertical" className="h-[300px]">
                        {countries.map((item) => (
                          <SelectItem value={item.value}>{item.label}</SelectItem>
                        ))}
                      </ScrollArea>
                    </SelectContent>
                  </Select>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="currency"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Devise</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="priority"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Priorité</FormLabel>
                  <FormControl>
                    <Input type="number" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="providerId"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Fournisseur</FormLabel>
                  <Select onValueChange={field.onChange} defaultValue={payload?.item?.provider.id}>
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      {providers?.map((provider) => (
                        <SelectItem key={provider.id} value={provider.id}>
                          {provider.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit">Mettre à jour</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
